import { useCordovaStore } from "@/stores/cordova";
import pinia from "./pinia";

const cordovaStore = useCordovaStore(pinia);

let _environment = "production";
let _apiUrl = "https://api.quantofaz.com.br";
let _platform = "web";

const betaMatch = window.location.host.match(/beta---quantofaz-app-(.+)\.run\.app/);
if (betaMatch) {
  _environment = "beta";
  _apiUrl = `https://beta---quantofaz-graphql-${betaMatch[1]}.run.app`;
}
const localMatch = window.location.host.match(/localhost:(3000)/);
if (localMatch) {
  _environment = "local";
  _apiUrl = `http://localhost:8080`;
}

// Platform detection: check URL param, then protocol/hostname, then default to web
const platformMatch = window.location.search.match(/platform=([^&]+)/);
if (platformMatch) {
  _platform = platformMatch[1];
} else if (
  window.location.protocol === 'file:' ||
  (window.location.protocol === 'https:' && window.location.hostname === 'localhost')
) {
  // Auto-detect Cordova by:
  // 1. file:// protocol (legacy Cordova)
  // 2. https://localhost (Cordova Android 10+)
  _platform = (window as any).device?.platform?.toLowerCase() || 'android';
}

export const environment = _environment;
export const apiUrl = _apiUrl;
export const platform = _platform;

export function loadCordovaScript() {
  // Don't load cordova.js if we're in web mode
  if (platform === "web") {
    return;
  }

  // Set up deviceready listener
  document.addEventListener("deviceready", cordovaStore._onDeviceReady);

  // Dynamically inject cordova.js
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `cordova.js`; // Cordova automatically serves the right platform version

  // Error handling
  script.onerror = () => {
    console.error('[Cordova] Failed to load cordova.js - are you running in a Cordova container?');
  };

  head.appendChild(script);
}
